"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
var isMaybeDefined = function (maybeT) { return maybeT !== undefined; };
/** Takes a dictionary containing `Maybe`s and returns a dictionary of all the non-empty values. */
// Inspired by
// http://hackage.haskell.org/package/base-4.12.0.0/docs/Data-Maybe.html#v:catMaybes
// https://github.com/gcanti/fp-ts/blob/42870714ebcae4ecf132291c687c845b6837b7d2/docs/Record.md#compact
exports.catMaybesDictionary = function (maybesDictionary) {
    return index_1.pickBy(
    // This cast shouldn't be necessary: https://github.com/Microsoft/TypeScript/issues/29246
    maybesDictionary, function (_key, value) { return isMaybeDefined(value); });
};
exports.mapValueIfDefined = function (fn) { return function (maybe) {
    return isMaybeDefined(maybe) ? fn(maybe) : undefined;
}; };
//# sourceMappingURL=maybe.js.map